import { ALL_SPREAD_DEFINITIONS } from './all-spreads.js';
const groupByCardCount = () => {
    const index = {};
    for (const definition of ALL_SPREAD_DEFINITIONS) {
        const count = definition.spread.cards;
        index[count] = [...(index[count] ?? []), definition];
    }
    return index;
};
export const SPREADS_BY_CARD_COUNT = groupByCardCount();
//# sourceMappingURL=by-card-count.js.map